import React, { useEffect } from "react";
import {
  CustomButton2,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomIcon,
  CustomInput,
  CustomTimePiker,
  CustomView,
} from "../../../../../../../../components";
import values from "../../../../../../../../values";
import {
  ICityItem,
  ICompanyItem,
  IOnSearchUser,
  IProvinceItem,
} from "../../../../../../../../types/common.interface";
import { useQuery } from "react-query";
import api from "../../../../../../../../api";
import { useTranslation } from "react-i18next";

import styles from "./style.module.sass";
import utils from "../../../../../../../../utils";
import Context from "../../../../../../../../context";

type Props = {
  values?: {
    gender?: string;
    school?: any;
    price?: string;
    field?: string;
    expire?: string;
    student?: any;
  };
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (event: any) => void;
};

const CreateOrUpdateService: React.FC<Props> = (
  props: Props
): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();

  const [showMoreInfo, setShowMoreInfo] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState({
    nationalCode: "",
    expireDate: "",
    firstName: "",
    lastName: "",
    school: "",
    gender: "",
    price: "",
  });

  const [searchedValueSchool, setSearchedValueSchool] =
    React.useState<IOnSearchUser>();
  const [selectedGender, setSelectedGender] = React.useState<any>(
    values.dropdownItems.GENDER.find(
      (item) => item.value === props.values?.gender
    )
  );
  const [selectedSchool, setSelectedSchool] = React.useState<any>();

  const [price, setPrice] = React.useState<string>(
    String(props?.values?.price || 900000)
  );
  const [nationalCode, setNationalCode] = React.useState<string>(
    props?.values?.student?.nationalCode || ""
  );
  const [firstName, setFirstName] = React.useState<string>(
    props?.values?.student?.firstName || ""
  );
  const [lastName, setLastName] = React.useState<string>(
    props?.values?.student?.lastName || ""
  );
  const [field, setField] = React.useState<string>(props?.values?.field || "");
  const [expire, setExpire] = React.useState<string>(
    props?.values?.expire || ""
  );
  const [selectedProvince, setSelectedProvince] = React.useState<
  IProvinceItem | undefined
>(undefined);
const [selectedCity, setSelectedCity] = React.useState<any>(undefined);


  const { selectedDriver } = React.useContext(Context.DriverScreen);


  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getAllSchool = useQuery(
    [values.useQueryKeys.getAllSchool, searchedValueSchool?.searchedValue],
    () =>
      api.post.common.findSchoolPost({
        search: {
          base: searchedValueSchool?.base?.value,
          value: searchedValueSchool?.searchedValue,
        },
        filters:{isApproved:true}
      })
  );

  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );

  const getAllCity = useQuery(
    [values.useQueryKeys.getAllCity, selectedProvince],
    () => api.get.common.getAllCity({ provinceCode: selectedProvince?.Code })
  );

  useEffect(() => {
    if (getAllProvince.data.result) {
      setSelectedProvince(
        getAllProvince.data.result?.find(
          (item: any) =>
            item._id === selectedDriver.schoolDriverInformation.province
        )
      );
    }
  }, [getAllProvince, selectedDriver.schoolDriverInformation.province]);

  useEffect(() => {
    if (getAllCity.data.result) {
      setSelectedCity(
        getAllCity.data.result?.find(
          (item: any) =>
            item._id === selectedDriver.schoolDriverInformation.city
        )
      );
    }
  }, [getAllCity, selectedDriver.schoolDriverInformation.city]);


  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function handleSubmit(): void {
    if (!lastName || lastName?.length < 3)
      setErrors({ ...errors, lastName: "نام خانوادگی اجباری میتاشد" });
    if (!firstName || firstName?.length < 2)
      setErrors({ ...errors, firstName: "نام اجباری میتاشد" });
    if (!selectedGender)
      setErrors({ ...errors, gender: "جنسیت اجباری میتاشد" });
    if (nationalCode && nationalCode?.length !== 10)
      setErrors({ ...errors, nationalCode: "کد ملی نادرست میتاشد" });
    // if (!price || price?.length < 5)
    //   setErrors({ ...errors, price: "قیمت اجباری میتاشد" });
    if (!selectedSchool)
      setErrors({ ...errors, school: "مدرسه اجباری میتاشد" });

    if (
      lastName?.length >= 3 &&
      firstName?.length >= 2 &&
      selectedGender
      // price?.length > 4
    ) {
      props.onSubmit({
        gender: selectedGender.value,
        school: selectedSchool?._id,
        nationalCode,
        firstName,
        lastName,
        expire: expire || "2024/09/21",
        price,
        field,
        province:selectedProvince?._id,
        city:selectedCity?._id
      });
    }
  }


  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  useEffect(() => {
    setSelectedSchool(
      getAllSchool?.data?.result?.find(
        (item: any) => item?._id === props.values?.school?._id
      )
    );
  }, [getAllSchool?.data?.result >= 1]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <CustomView.Container className={styles.createOrUpdateService}>
      <CustomView.Row className={styles.title}>ویرایش سرویس</CustomView.Row>
      <CustomView.Row className={styles.body}>
        <CustomView.Row>
          <CustomView.Column medium={6}>
            <label className={styles.label}>انتخاب مردسه</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.SCHOOL_BASE_SEARCH.map(
                (item) => ({ ...item, title: t(item.title as string) })
              )}
              items={getAllSchool?.data?.result}
              itemName="name"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedSchool(event);
                setErrors({ ...errors, school: "" });
              }}
              defaultItem={selectedSchool}
              searchedValue={searchedValueSchool}
              setSearchedValue={setSearchedValueSchool}
              placeHolder={t("selectSchool")}
              isLoading={getAllSchool.isLoading}
              selectedBaseSearch={searchedValueSchool?.base?.value}
            />
            <div className={styles.error}>
              {errors.school !== "" && errors.school}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <CustomInput
              maxLength={13}
              label={"قیمت سرویس"}
              value={utils.convertNumberToPrice(Number(price))}
              error={errors.price !== ""}
              errorText={errors.price}
              onValueChange={(
                event: React.ChangeEvent<HTMLInputElement>
              ): void => {
                setPrice(
                  String(utils.convertPriceToNumber(event.target.value))
                );
                setErrors({ ...errors, price: "" });
              }}
            />
          </CustomView.Column>
        </CustomView.Row>

        <CustomView.Row>
          <CustomView.Column medium={6}>
            <CustomInput
              label={"نام"}
              value={firstName}
              error={errors.firstName !== ""}
              errorText={errors.firstName}
              onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFirstName(event.target.value);
                setErrors({ ...errors, firstName: "" });
              }}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <CustomInput
              label={"نام خانوادگی"}
              value={lastName}
              error={errors.lastName !== ""}
              errorText={errors.lastName}
              onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setLastName(event.target.value);
                setErrors({ ...errors, lastName: "" });
              }}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row>
          <CustomView.Column medium={6}>
            <label className={styles.label}>انتخاب جنسیت</label>
            <CustomDropdownSearch
              items={values.dropdownItems.GENDER}
              itemName="name"
              placeHolder={t("selectGender")}
              defaultItem={selectedGender}
              onSelectItem={(event: any) => {
                setSelectedGender(event);
                setErrors({ ...errors, gender: "" });
              }}
            />
            <div className={styles.error}>
              {errors.gender !== "" && errors.gender}
            </div>
          </CustomView.Column>
        </CustomView.Row>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            className="more-info"
            onClick={() => {
              setShowMoreInfo(!showMoreInfo);
            }}
            style={{
              fontSize: "12px",
              cursor: "pointer",
              padding: "1rem",
              width: "8rem",
            }}
          >
            {t("more_info")} <i className={"fa-solid fa-chevron-down"}></i>
          </div>
        </div>
        {showMoreInfo && (
          <>
            <CustomView.Row>
              <CustomView.Column medium={6}>
                <label className={styles.label}>انتخاب استان</label>
                <CustomDropdownSearch
                  items={getAllProvince?.data?.result}
                  itemName="Name"
                  defaultItem={selectedProvince}
                  onSelectItem={(event: IProvinceItem) =>
                    setSelectedProvince(event)
                  }
                  placeHolder={t("selectProvince")}
                  isLoading={getAllProvince.isLoading}
                  isSearch
                />
              </CustomView.Column>
              <CustomView.Column medium={6}>
                <label className={styles.label}>انتخاب شهر</label>
                <CustomDropdownSearch
                  items={getAllCity?.data?.result}
                  itemName="Name"
                  defaultItem={selectedCity}
                  onSelectItem={(event: ICityItem) => setSelectedCity(event)}
                  placeHolder={t("selectCity")}
                  isLoading={getAllCity.isLoading}
                  isSearch
                />
              </CustomView.Column>
            </CustomView.Row>

            <CustomView.Row>
              <CustomView.Column medium={6}>
                <CustomInput
                  label={"بایه تحصیلی"}
                  value={field}
                  onValueChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setField(event.target.value)
                  }
                />
              </CustomView.Column>
              <CustomView.Column medium={6}>
                <div style={{ zIndex: 100000 }}>
                  <label className={styles.label}>تاریخ شروع سرویس</label>
                  <CustomTimePiker
                    defaultValue={expire}
                    onChange={(event: string) => {
                      setErrors({
                        ...errors,
                        expireDate: "",
                      });
                      setExpire(event);
                    }}
                    // minDate={new Date()}
                  />
                  <div className="error">
                    {errors.expireDate !== "" && errors.expireDate}
                  </div>
                </div>
              </CustomView.Column>
              <CustomView.Column medium={6}>
                <CustomInput
                  label={"گد ملی"}
                  maxLength={10}
                  value={nationalCode}
                  error={errors.nationalCode !== ""}
                  errorText={errors.nationalCode}
                  onValueChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => {
                    setNationalCode(event.target.value);
                    setErrors({ ...errors, nationalCode: "" });
                  }}
                />
              </CustomView.Column>
            </CustomView.Row>
          </>
        )}

        <CustomView.Row className={styles.footer}>
          <CustomView.Column medium={6}>
            <CustomButton2
              title="تایید"
              onClick={handleSubmit}
              isLoading={props.isLoading}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <CustomButton2
              title="لغو"
              type={"danger"}
              onClick={props.onClose}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Row>
    </CustomView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default CreateOrUpdateService;
